import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import Controller from '@ember/controller';

export default class TimeZoneMatchController extends Controller {
  @service analytics;
  @service api;

  customer = null;
  idOrEmail = null;
  requestedIdOrEmail = null;

  requestTest = task(
    {
      drop: true,
    },
    async () => {
      let requestedIdOrEmail = this.get('idOrEmail');

      try {
        this.set('requestedIdOrEmail', requestedIdOrEmail);

        let response = await this.get('api').post('verify/time_zone_match', {
          data: { customer: requestedIdOrEmail },
          ignoreErrors: true,
          includeStatus: true,
        });

        this.set('customer', response);

        return true;
      } catch (e) {
        return false;
      } finally {
        this.analytics.track('message', 'time_zone_attribute_tested');
      }
    },
  );
}
